module.exports = __webpack_public_path__ + "img/ccdstimelinetopnew.84b52a9b.png";